import { render, staticRenderFns } from "./CustomMenuCheck.vue?vue&type=template&id=bc7830e0&scoped=true&"
import script from "./CustomMenuCheck.vue?vue&type=script&lang=js&"
export * from "./CustomMenuCheck.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenuCheck.vue?vue&type=style&index=0&id=bc7830e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7830e0",
  null
  
)

export default component.exports